<template>
    <div class="login">
        <div class="left">
        </div>
        <div class="right">
            <div class="title">
                账号登录
            </div>
            <div class="inputs" style="margin-bottom:20px">
              <!-- <img src="/imgs/user/icon_phone.png" alt=""> -->
              <!-- 账号： -->
              <input type="text" v-model="userName" placeholder="请输入手机号">
            </div>
            <div class="inputs">
              <!-- <img src="/imgs/user/icon_password.png" alt="" style="top:16px;"> -->
              <!-- 密码： -->
              <input type="password" v-model="password" placeholder="请输入密码">
            </div>
            <!-- <div class="warning">{{warning}}</div> -->
            <div class="button" @click="login">
              登录
            </div>
            <div class="bottom">
              <div class="bottom_left" @click="$router.push('/register')">个人注册</div>
              <div class="bottom_right" @click="$router.push('/forgetPassword')">忘记密码?</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "login",
        metaInfo () {
            return {
                title: this.Pctitle,
                meta: [{                 // set meta
                    name: 'keyWords',
                    content: this.copyright.keywords,
                }],
                link: [{                 // set link
                    rel: 'icon',
                    href: this.copyright.mark
                }]
            }
        },  
        data(){
            return{
                userName:'',
                password:'',
                webSite:'',
                warning:''
            }
        },
        methods:{
            //登录
            login(){
                let regUser= /(^1[123456789]\d{9}$)/;
                let regPw=/[a-zA-z0-9!@#$%^&*.?]{6,20}/;
                let _this=this;
                this.warning=''
                if(!this.userName){
                    this.warning='账号不能为空'
                    this.$message({
                      message: '账号不能为空',
                      type: 'error'
                    });
                    return;
                }
                if(!this.password){
                    this.warning='密码不能为空'
                    this.$message({
                      message: '密码不能为空',
                      type: 'error'
                    });
                    return;
                }
                if(!regUser.test(this.userName)){
                    this.warning='请输入正确的手机号'
                    this.$message({
                      message: '请输入正确的手机号',
                      type: 'error'
                    });
                    return;
                }
                if(!regPw.test(this.password)){
                    this.warning='密码不能少于6位字符，不能超过20位字符'
                    this.$message({
                      message: '密码不能少于6位字符，不能超过20位字符',
                      type: 'error'
                    });
                    return;
                }
                this.$ajax.post(this.G_uri + this.ports.user.login, {
                    userName: this.userName,
                    password: this.password,
                    webSite:this.$OEMdomain
                }).then((res)=>{
                    if(res.data.code==2000){
                            let data=res.data.data;
                            if(data.is_band_card==1){
                                _this.$router.push({
                                    name:'绑定校园卡',
                                    params:{
                                        userName:_this.userName,
                                        password:_this.password
                                    }
                                })
                                return;
                            }
                            if(data.is_band_phone==1){
                                _this.$router.push({
                                    name:'绑定手机号',
                                    params:{
                                        card:_this.userName,
                                        cardPw:_this.password
                                    }
                                })

                                return;
                            }
                            if(data.token) {
                                console.log(data)
                                window.sessionStorage.setItem('ymtxToken', data.token);
                                window.localStorage.setItem('ymtxLocalToken',data.token);
                                window.sessionStorage.setItem('lct_token', data.token);
                                
                                // userType:1学生，2家长，3咨询师；status：3是已经完成问卷
                                let userType = data.userInfo.userType;

                                if(userType == 1){
                                   sessionStorage.setItem('userType','student')
                                   window.localStorage.setItem('localUserType','student');
                                    let status = data.userInfo.isStatus;
                                    if (data.isImproveInformation == 2) {
                                        _this.$router.push('/perfectInformation');
                                        return;
                                    }
                                    this.$store.commit('getStudentStatus', status);
                                    _this.$router.push('/careerArchives')
                                } else if (userType == 2) {
                                    sessionStorage.setItem('userType','parent')
                                    window.localStorage.setItem('localUserType','parent');
                                    let status = data.userInfo.isStatus;
                                    window.sessionStorage.setItem('parentName', data.userInfo.name);
                                    window.localStorage.setItem('localParentName', data.userInfo.name);

                                    if (status == 3) {
                                        this.$router.push('/parent/home/quesMessage');
                                    } else {
                                        this.$router.push('/parent/home/ques');
                                    }
                                    this.$store.commit('getParentStatus', status)
                                } else if (userType == 3) {
                                    sessionStorage.setItem('userType','consultant')
                                    window.localStorage.setItem('localUserType','consultant');
                                    this.$router.push('/consultant/home');
                                }
                            }

                    }else{
                        _this.warning=res.data.msg;
                        this.$message({
                          message: res.data.msg,
                          type: 'error'
                        });

                    }
                })
            },
            get_footer_copyright(){
                var OEMdomain = this.$OEMdomain=='localhost'?'http://39.98.37.134':this.$OEMdomain,
                _this = this;
                this.$ajax.post(this.G_uri + '/website/getConfigInfo', {
                    webSite: OEMdomain
                }).then(function(res){
                    if(res.data.code == 2000){
                        _this.copyright = res.data.data;
                        _this.Pctitle = res.data.data.title
                    }
                })
            }, 
        },
        mounted(){
          console.log('ggggggg')
          this.get_footer_copyright();        
         $('.user').css('background',"/imgs/xueyezixun/consultant/student/bg.png")
        },
        beforeCreate(){

        }
    }
</script>
<style scoped lang="less">
    *{
        box-sizing: border-box;
        letter-spacing: 2px;
    }
    .login{
        width: 1146px;
        height: 595px;
        background:#fff;
        position: absolute;
        left: 50%;
        top:50%;
        // margin-top:-275px;
        // margin-left: -498px;
        border-radius: 13px;
        transform: translate(-50%,-50%);

        &>img{
          position: relative;
          top:-1px;
        }
        .left{
          background: url(/imgs/user/login_left_01.png) no-repeat;
          width: 606px;
          height: 100%;
          float: left;
          background-size: 100%;
          background-position: -3px -3px;
        }
        .right{
          width: 534px;
          float: right;
          font-size: 15px;
        }
        .warning{
            text-align: center;
            color:red;
            line-height: 46px;
            height: 46px;
        }
        .title{
          line-height: 28px;
          color: #333333;
          font-size: 20px;
          text-align: center;
          margin: 110px auto 50px;
          font-weight: bold;
        }
        .inputs{
          width: 407px;
          height: 44px;
          display: block;
        //   border-bottom: 1px solid #979797;
          margin: 0 auto;
          line-height: 42px;
          color: #7C7C7C;
        //   padding-left: 16px;
          position: relative;
          background: rgba(36, 130, 243, 0.1);
            border-radius: 4px;
            border: 1px solid rgba(25, 122, 239, 0.3);
        //   &>img{
        //     position: absolute;
        //     left: 0;
        //     top: 15px;
        //   }
          input{
            border: none;
            height: 42px;
            width: 330px;
            line-height: 42px;
            display: inline-block;
            padding-left: 30px;
            background: none;
          }
          input:-webkit-autofill {
               -webkit-box-shadow: none !important;
            }
            /deep/input:-internal-autofill-selected{
              appearance: menulist-button;
              background: none !important;
              background-image: none !important;
              color: #7C7C7C !important;
            }         
        }
        .button{
          width: 407px;
          height: 56px;
          background: #3D90F6;
          border-radius: 28px;
          margin: 0 auto;
          font-size: 16px;
          line-height: 56px;
          text-align: center;
          color:#fff;
          cursor: pointer;
          margin-top: 20px;
        }
        .bottom{
          margin: 20px auto;
          width: 407px;
          font-size:13px;
          .bottom_left{
            float: left;
            color: #3D90F6;
            cursor: pointer;
          }
          .bottom_right{
            float: right;
            cursor: pointer;
          }
        }
    }
</style>
